// Centralized API base URL configuration
// Priority: REACT_APP_API_URL env var -> development localhost -> production live API
export const API_BASE_URL = process.env.REACT_APP_API_URL || (process.env.NODE_ENV === 'development' ? 'http://127.0.0.1:9000' : 'https://api.litesale.store');

export default API_BASE_URL;
